import React from 'react'
import { Link } from 'react-router-dom'
import { HiChevronRight } from 'react-icons/hi'

export default function Breadcrumbs({ items }) {
    if (!items || items.length === 0) return null

    return (
        <nav className="flex mb-4" aria-label="Breadcrumb">
            <ol className="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
                {items.map((item, idx) => {
                    const isLast = idx === items.length - 1
                    return (
                        <li key={idx} className="inline-flex items-center gap-1.5">
                            {idx > 0 && <HiChevronRight size={14} className="text-gray-400" />}
                            {item.link && !isLast ? (
                                <Link to={item.link} className="hover:text-primary dark:hover:text-primary transition-colors">
                                    {item.label}
                                </Link>
                            ) : (
                                <span className={isLast ? 'text-black dark:text-white font-medium' : ''}>
                                    {item.label}
                                </span>
                            )}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}
